module.exports = __webpack_public_path__ + "static/img/circle.a410daa2.png";